/**
 * HomeGroupWA Landing Page JS Include
 *
 * @author Red Tiki <info@redtiki.com.au>
 */

window.LandingPageObject = function(opts) {
    var landingpage_obj = $.extend(new window.PageObject({}), {
        //page interactivity
        setupCTAs: function() {
            var self = this;

            $('#finance-per-weekModal').on('show.bs.modal', function(event) {
                self.onPerWeekModalShow(event, $(this));
            });

            $('#finance-first-home-ownerModal').on('show.bs.modal', function(event) {
                self.onFirstHomeOwnerModalShow(event, $(this));
            });

            $('#finance-depositModal').on('show.bs.modal', function(event) {
                self.onDepositModalShow(event, $(this));
            });

            $('#finance-qualifyModal').on('show.bs.modal', function(event) {
                self.onQualifyModalShow(event, $(this));
            });

            $('#finance-per-weekModal').on('hide.bs.modal', function(event) {
                self.onPerWeekModalHide(event, $(this));
            });

            $('#finance-first-home-ownerModal').on('hide.bs.modal', function(event) {
                self.onFirstHomeOwnerModalHide(event, $(this));
            });

            $('#finance-depositModal').on('hide.bs.modal', function(event) {
                self.onDepositModalHide(event, $(this));
            });

            $('#finance-qualifyModal').on('hide.bs.modal', function(event) {
                self.onQualifyModalHide(event, $(this));
            });
        },

        onPerWeekModalShow: function(e, modal) {
            var url = this.currentURL + '#finance-per-weekModal';
            var title = this.pageTitle + ' (Per Week CTA)';
            this.changePage(url, this.pageClass, this.pageID, title);
            this.trackPageView(url, title);
        },

        onPerWeekModalHide: function(e, modal) {
            this.backPage();
        },

        onFirstHomeOwnerModalShow: function(e, modal) {
            var url = this.currentURL + '#finance-first-home-ownerModal';
            var title = this.pageTitle + ' (First Home Owner CTA)';
            this.changePage(url, this.pageClass, this.pageID, title);
            this.trackPageView(url, title);
        },

        onFirstHomeOwnerModalHide: function(e, modal) {
            this.backPage();
        },

        onDepositModalShow: function(e, modal) {
            var url = this.currentURL + '#finance-depositModal';
            var title = this.pageTitle + ' (Deposit CTA)';
            this.changePage(url, this.pageClass, this.pageID, title);
            this.trackPageView(url, title);
        },

        onDepositModalHide: function(e, modal) {
            this.backPage();
        },

        onQualifyModalShow: function(e, modal) {
            var url = this.currentURL + '#finance-qualifyModal';
            var title = this.pageTitle + ' (Per Week CTA)';
            this.changePage(url, this.pageClass, this.pageID, title);
            this.trackPageView(url, title);
        },

        onQualifyModalHide: function(e, modal) {
            this.backPage();
        },

        //event handlers...
        onInit: function() {},
        onReady: function() {
            this.setupCTAs();
        },
        onResize: function() {},
        onLoad: function() {}
    });

    if (opts) {
        return $.extend(landingpage_obj, opts);
    } else {
        return landingpage_obj;
    }
};
